export default __webpack_public_path__ + "static/media/sine-cosine.8c91af21.gif";